import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { LoginForm } from '../components/LoginForm';

export const LoginPage: React.FC<{ onLogin: (token: string) => void }> = ({ onLogin }) => (
  <Container maxWidth="sm" sx={{ px: { xs: 2, sm: 3 } }}>
    <Box sx={{ 
      mt: { xs: 4, sm: 6, md: 8 }, 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center' 
    }}>
      <Typography 
        variant="h2" 
        align="center" 
        sx={{ 
          mb: 3, 
          fontWeight: 800, 
          fontSize: { xs: '3rem', sm: '3.5rem', md: '4rem' },
          letterSpacing: 4,
          background: 'linear-gradient(135deg, #2d7a5f 0%, #1e5545 50%, #4facfe 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          textShadow: '0 2px 10px rgba(45, 122, 95, 0.3)'
        }}
      >
        ZYNEX
      </Typography>
      <Typography 
        variant="h5" 
        align="center" 
        sx={{ 
          mb: 1, 
          fontWeight: 600,
          fontSize: { xs: '1.25rem', sm: '1.5rem' }
        }}
      >
        Cloud Management Platform
      </Typography>
      <Typography 
        variant="body2" 
        align="center" 
        color="text.secondary" 
        sx={{ 
          mb: 4,
          fontSize: { xs: '0.875rem', sm: '1rem' }
        }}
      >
        Secure Multi-Tenant Infrastructure
      </Typography>
    </Box>
    <LoginForm onLogin={onLogin} />
  </Container>
);
